import { useQuery } from "@tanstack/react-query";
import { isEmpty } from "lodash/fp";
import { useParams } from "react-router-dom";

import { getTranscript } from "@app/analytics/api/meetingReport";
import { ResponseError } from "@app/common/api";

const DEFAULT_OPTS = { enabled: true };

const useTranscriptQuery = (opts = DEFAULT_OPTS) => {
  const { sessionId } = useParams();

  return useQuery({
    queryKey: ["transcript", sessionId],
    queryFn: () => getTranscript(sessionId!),
    enabled: opts.enabled && !isEmpty(sessionId),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    // don't retry if transcript doesn't exist or user is not authorized to view it
    retry: (failureCount, error: ResponseError) =>
      failureCount < 3 &&
      (!error?.response?.status ||
        error.response.status < 400 ||
        error.response.status > 499),
  });
};

export default useTranscriptQuery;
